import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import {
  Button as MUIButton,
  Chip,
  IconButton,
  Paper,
  Stack,
  Table,
  TableContainer,
  Typography,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {MoreOptions} from '../Table/assets/MoreOptions';
import {toaster} from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import {SlidingPaneEdit} from '../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import api from '../../services/api';
import {SlidingPaneAddNew} from '../Page/SlidingPaneAddNew';
import TableBody from '@mui/material/TableBody';
import {serviceProviderEventStaff} from '../../schema/serviceProviderEventStaff';
import {formatNumber} from '../../reducer/actions/formatNumber';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import {serviceProviderEventStaffSingle} from '../../schema/serviceProviderEventStaffSingle';
import EditIcon from '@mui/icons-material/Edit';

export const Staff = ({
                        schema,
                        values,
                        tableType,
                      }: {
  schema: any;
  values: any;
  tableType: string;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [properties, setProperties] = useState<any>(undefined);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [addingEntity, setAddingEntity] = useState<any>({
    schema: undefined,
  });
  const ref = useRef<any>(null);
  const [loading, setLoading] = useState<any>(false);
  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: schema,
    row: {},
    key: undefined,
  });

  const fetchContacts = useCallback(() => {
    const searchParams = new URLSearchParams({
      /*activity: values?.id,*/
    });
    setLoading(true);
    api
      .get(`/event-staff-by-service-provider/${values.id}`, searchParams)
      .then((res: any) => {
        setProperties(res);
        setLoading(false);
      });

    if (ref.current && values?.activity_category_id === 9) {
      const closestParent = ref.current?.closest('.MuiGrid-root');
      if (closestParent) {
        const parent = closestParent?.parentElement;
        const container = parent?.parentElement;
        container.style.display = 'none';
      }
    }

  }, [values, ref]);

  useEffect(() => {
    fetchContacts();
  }, [values, schema]);

  return (
    <>
      <TableContainer
        ref={ref}
        component={Paper}>
        <Table
          aria-label="simple table"
          size="small"
          sx={{
            '& .MuiTableBody-root .MuiTableRow-root': {
              background: '#fff',
            },
          }}
        >
          <TableHead
            sx={{
              '& .MuiTableCell-root': {
                color: 'inherit',
                border: 'none',
              },
              '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                border: 'none',
                fontSize: '14px',
                p: '10px',
              },
              background: '#256861',
              color: '#fff',
            }}
          >
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  overflowWrap: 'anywhere',
                },
              }}
            >
              <TableCell
                sx={{
                  width: '50px',
                }}
              ></TableCell>
              <TableCell
                sx={{
                  width: '150px',
                }}
              >
                Staff
              </TableCell>
              <TableCell sx={{}}>Services</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {properties &&
              properties.map((staffUser: any) => {
                return (
                  <TableRow>
                    <TableCell
                      sx={{
                        padding: '5px',
                      }}
                    >
                      <MoreOptions
                        clickOnEdit={() => {
                          setOpenedSlidingPane({
                            schema: serviceProviderEventStaff,
                            row: staffUser,
                          });
                        }}
                        clickOnDelete={() => {
                          setOpenConfirmDialog({
                            row: {id: staffUser?.service_provider_id},
                            schema: serviceProviderEventStaffSingle,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        '& > b': {
                          textDecoration: 'underline',
                        },
                        cursor: 'pointer',
                        '&:hover': {
                          background: '#f3f3f3',
                        },
                      }}
                      onClick={() => {
                        setOpenedSlidingPane({
                          schema: serviceProviderEventStaff,
                          row: staffUser,
                        });
                      }}
                    >
                      <Stack>
                        <b>{staffUser?.event_staff}</b>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {staffUser?.services.map((item: any, index: number) => {
                        return (
                          <Chip
                            sx={{
                              '& .MuiChip-label': {
                                pr: '3px',
                              },
                            }}
                            label={
                              <>
                                <Stack
                                  direction={'row'}
                                  gap={'4px'}
                                  alignItems={'center'}
                                >
                                  <Typography fontSize={'12px'}>
                                    {item?.name}
                                  </Typography>
                                  {item?.price && (
                                    <Typography
                                      variant={'caption'}
                                      color={'#666'}
                                    >
                                      {`(${formatNumber(item?.price)} ${
                                        item?.currency
                                      })`}
                                    </Typography>
                                  )}
                                  <IconButton
                                    key={`chip-edit-button-${item?.id}-${item}`}
                                    id={`chip-edit-button-${item?.id}-${item}`}
                                    aria-label="edit"
                                    size="small"
                                    color={'primary'}
                                    onClick={(event: any) => {
                                      if (
                                        event?.target?.nodeName === 'BUTTON'
                                      ) {
                                        return false;
                                      }
                                      setOpenedSlidingPane({
                                        schema: serviceProviderEventStaffSingle,
                                        row: item,
                                      });
                                      return true;
                                    }}
                                    sx={{
                                      padding: '0px',
                                      '& .MuiSvgIcon-root': {
                                        width: '15px',
                                        height: '15px',
                                      },
                                    }}
                                  >
                                    <EditIcon fontSize="small"/>
                                  </IconButton>
                                  <IconButton
                                    key={`chip-delete-button-${item?.id}-${index}`}
                                    id={`chip-delete-button-${item?.id}-${index}`}
                                    aria-label="delete"
                                    size="small"
                                    color={'error'}
                                    sx={{
                                      padding: '0px',
                                      paddingRight: '8px',
                                      '& .MuiSvgIcon-root': {
                                        width: '15px',
                                        height: '15px',
                                      },
                                    }}
                                    onClick={(event) => {
                                      console.log(
                                        'You clicked the delete button'
                                      );
                                      setOpenConfirmDialog({
                                        row: item,
                                        schema: serviceProviderEventStaff,
                                      });
                                    }}
                                  >
                                    <DeleteIcon fontSize="small"/>
                                  </IconButton>
                                </Stack>
                              </>
                            }
                          />
                        );
                      })}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <div>
        <Tooltip
          title={`Add new`}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -14],
                  },
                },
              ],
            },
          }}
        >
          <IconButton
            color={'primary'}
            onClick={() => {
              setCurrentAddNewPaneEntity({
                row: {
                  id: 'new',
                  service_provider: {
                    id: values.id,
                    name: values.name,
                  },
                },
                schema: serviceProviderEventStaff,
                key: 'service_provider',
              });
            }}
          >
            <AddIcon/>
          </IconButton>
        </Tooltip>
      </div>

      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={schema}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
              fetchContacts();
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {'Are you sure you want to delete it?'}
          </DialogTitle>
          <DialogActions>
            <MUIButton
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
            >
              Cancel
            </MUIButton>
            <MUIButton
              variant={'contained'}
              color={'error'}
              onClick={() => {
                const deletedRow = openConfirmDialog?.row;
                openConfirmDialog?.schema.client
                  .delete(deletedRow.id as number, {id: deletedRow.id})
                  .then((res: any) => {
                    toaster.show({
                      intent: 'success',
                      message: `Successfully deleted ${
                        openConfirmDialog?.schema.name
                      }: ${
                        deletedRow?.name ? deletedRow?.name : deletedRow?.id
                      }`,
                    });
                    setOpenConfirmDialog(false);
                    fetchContacts();
                  })
                  .catch((e: any) => {
                    console.log(e);

                    toaster.show({
                      icon: 'error',
                      message: `Error: Unable to delete ${schema.name}: ${
                        deletedRow?.name ? deletedRow?.name : deletedRow?.id
                      }`,
                      intent: 'danger',
                    });
                  });
              }}
              autoFocus
            >
              Delete
            </MUIButton>
          </DialogActions>
        </Dialog>
      )}

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            fetchContacts();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
